export default {
    add_new_topic: "Ajouter un nouveau sujet",
    confirm_delete_reply: "Etes vous sûr de vouloir supprimer votre réponse?",
    confirm_delete_topic: "Voulez-vous vraiment supprimer ce sujet?",
    delete_reply: "Supprimer la réponse",
    delete_topic: "Supprimer le sujet",
    delete: "Supprimer",
    edit: "Éditer",
    error_changing_answer_status: "Erreur lors du changement de l'état de la réponse",
    error_changing_topic_status: "Erreur lors de la modification de l'état du sujet",
    error_deleting_reply: "Erreur lors de la suppression de la réponse",
    error_deleting_topic: "Erreur lors de la suppression du sujet",
    error_editing_reply: "Erreur lors du changement de réponse",
    error_editing_topic: "Erreur lors de la modification du sujet",
    in_this_course: "dans ce cours",
    reply_deleted: "Réponse effacée",
    reply_edited: "Réponse modifiée",
    search_topic: "Sujet de recherche",
    there_are_no_topics_in_this_course_yet: "Il n'y a pas encore de sujet dans ce cours",
    topic_added_successfully: "Sujet ajouté avec succès",
    topic_deleted: "Sujet supprimé",
    topic_edited: "Sujet modifié",
    topic_is_closed: "Ce sujet est fermé et n'accepte plus de réponses.",
    topic_plural: "sujets",
    topic: "sujet",
}
